import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

@Component({
  selector: 'app-micro-product-details-page',
  templateUrl: './micro-product-details-page.component.html',
  styleUrls: ['./micro-product-details-page.component.scss'],
})
export class MicroProductDetailsPageComponent implements OnInit {
  productTitle: string;
  industryReport : any;
  deviceType: string;

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private seoService: SeoService,
  ) {
    this.deviceType = localStorage.getItem('deviceType');
    this.route.params.subscribe((params) => {
      this.productTitle = params.report_url;
      this.getIndustryReportByURL();
    });
  }

  ngOnInit(): void {
    this.seoService.getSeo('report');
  }

  getIndustryReportByURL() {
    this.companyService
      .getIndustryReportByURL(this.productTitle)
      .then((data) => {
        this.industryReport = data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
